const ASSOCIATED_OBJECT_TYPES = {
	DISCUSSION_THREAD: 'discussion-thread',
	EVENT: 'event',
	EVENT_STAGE: 'event-stage',
	PRODUCT: 'product',
};

const LANGUAGE_FALLBACK = 'en';

const LANGUAGE_UNDETERMINED = 'und';

const SCOPES = {
	GLOBAL: 'global',
	ORGANIZATION: 'organization',
	TRACK: 'track',
	COURSE: 'course',
	SESSION: 'session',
};

const TRANSLATION_PROVIDERS = {
	GOOGLE: 'google',
	DEEPL: 'deepl',
};

const LANGUAGE_ALIASES = {
	zh: ['zh-CN'],
	he: ['iw'],
	jv: ['jw'],
};

module.exports = {
	ASSOCIATED_OBJECT_TYPES,
	LANGUAGE_ALIASES,
	LANGUAGE_FALLBACK,
	LANGUAGE_UNDETERMINED,
	SCOPES,
	TRANSLATION_PROVIDERS,
};
